import Message from './src/message.js';
export default Message;



// WEBPACK FOOTER //
// ./src/packages/message/index.js